import React from 'react';
import cn from 'classnames';

import * as styles from './FormGrid.module.scss';

export const FormColumn = ({ sizes = [], children, className }) => {
  return (
    <div
      className={cn(
        styles.column,
        className,
        sizes.map(el => styles[el]),
      )}
    >
      {children}
    </div>
  );
};
